// Runtime config shim. Reads window.APP_CONFIG (set by /config.js, which
// entrypoint.sh rewrites at container boot) → VITE_API_URL (build-time) →
// '/api' (same-origin fallback for local dev under Vite).
// Per FRONTEND-PATTERNS §Runtime config.

declare global {
  interface Window {
    APP_CONFIG?: { apiUrl?: string };
  }
}

export const apiUrl: string =
  (typeof window !== 'undefined' && window.APP_CONFIG?.apiUrl) ||
  (import.meta.env.VITE_API_URL as string | undefined) ||
  '/api';
